import SpecialistCard from 'components/specialist-card';
import { Text } from 'components/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { breakpoints } from 'styles/theme';
import { SpecialistWithExpandedRefs } from 'utils/queries';

export interface SpecialistListProps {
  specialists: SpecialistWithExpandedRefs[];
}

const Wrapper = styled.div`
  padding: var(--space-2);

  @media screen and (min-width: ${breakpoints.small}) {
    padding: 0;
  }

  > * + * {
    margin-top: var(--space-2);
    padding-top: var(--space-2);
    border-top: 1px solid var(--color-grey200);

    @media screen and (min-width: ${breakpoints.medium}) {
      margin-top: var(--space-5);
      padding-top: var(--space-5);
    }
  }
`;

const SpecialistList: FC<SpecialistListProps> = ({ specialists }) => {
  return (
    <Wrapper>
      {specialists.length === 0 && <Text>No results</Text>}
      {specialists.map((specialist) => (
        <SpecialistCard data={specialist} key={specialist._id} />
      ))}
    </Wrapper>
  );
};

export default SpecialistList;
